import React from "react";

const Content = () => {
    return (
        <>
            <main id="body-content">
                <section className="wide-tb-100 pb-0">
                    <div className="container pos-rel">
                        <div className="row">
                            <div className="col-md-6">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Headings</h3>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <h1 className="txt-orange">Heading H1</h1>
                                        <p>Mauris at ultricies eros. Morbi vel dui nec arcu suscipit euismod. Phasellus pellentesque lectus eget quam ullamcorper consectetur.</p>
                                    </div>
                                    <div className="col-sm-6">
                                        <h2 className="txt-orange">Heading H2</h2>
                                        <p>Mauris at ultricies eros. Morbi vel dui nec arcu suscipit euismod. Phasellus pellentesque lectus eget quam ullamcorper consectetur.</p>
                                    </div>
                                    <div className="col-sm-6">
                                        <h3 className="txt-blue">Heading H3</h3>
                                        <p>Mauris at ultricies eros. Morbi vel dui nec arcu suscipit euismod. Phasellus pellentesque lectus eget quam ullamcorper consectetur.</p>
                                    </div>
                                    <div className="col-sm-6">
                                        <h4>Heading H4</h4>
                                        <p>Mauris at ultricies eros. Morbi vel dui nec arcu suscipit euismod. Phasellus pellentesque lectus eget quam ullamcorper consectetur.</p>
                                    </div>
                                    <div className="col-sm-6">
                                        <h5>Heading H5</h5>
                                        <p>Mauris at ultricies eros. Morbi vel dui nec arcu suscipit euismod. Phasellus pellentesque lectus eget quam ullamcorper consectetur.</p>
                                    </div>
                                    <div className="col-sm-6">
                                        <h6>Heading H6</h6>
                                        <p>Mauris at ultricies eros. Morbi vel dui nec arcu suscipit euismod. Phasellus pellentesque lectus eget quam ullamcorper consectetur.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Others Heading</h3>
                                <div className="page-header">
                                    <h1 className="txt-orange">Morbi vel dui nec arcu suscipit euismod. <small className="txt-ligt-gray">Subtext for header</small></h1>
                                </div>
                                <p className="lead">Mauris at ultricies eros. Morbi vel dui nec arcu suscipit euismod. Phasellus pellentesque lectus eget quam ullamcorper consectetur. Suspendisse sed turpis non nulla auctor posuere. Nulla ut libero tortor. Nam tortor metus, accumsan in tincidunt a, aliquam vitae diam. </p>
                                <small>Mauris at ultricies eros. Morbi vel dui nec arcu suscipit euismod. Phasellus pellentesque lectus eget quam ullamcorper consectetur. Suspendisse sed turpis non nulla auctor posuere. Nulla ut libero tortor. Nam tortor metus, accumsan in tincidunt a, aliquam vitae diam. </small>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-5 why-choose">
                    <div className="container pos-rel">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Default Grid System</h3>
                                <div className="bs-docs-grid">
                                    <div className="show-grid row">
                                        <div className="col-md-1"><span>.col-md-1</span></div>
                                        <div className="col-md-1"><span>.col-md-1</span></div>
                                        <div className="col-md-1"><span>.col-md-1</span></div>
                                        <div className="col-md-1"><span>.col-md-1</span></div>
                                        <div className="col-md-1"><span>.col-md-1</span></div>
                                        <div className="col-md-1"><span>.col-md-1</span></div>
                                        <div className="col-md-1"><span>.col-md-1</span></div>
                                        <div className="col-md-1"><span>.col-md-1</span></div>
                                        <div className="col-md-1"><span>.col-md-1</span></div>
                                        <div className="col-md-1"><span>.col-md-1</span></div>
                                        <div className="col-md-1"><span>.col-md-1</span></div>
                                        <div className="col-md-1"><span>.col-md-1</span></div>
                                    </div>
                                    <div className="show-grid row">
                                        <div className="col-md-6"><span>.col-md-6</span></div>
                                        <div className="col-md-6"><span>.col-md-6</span></div>
                                    </div>
                                    <div className="show-grid row">
                                        <div className="col-md-4"><span>.col-md-4</span></div>
                                        <div className="col-md-4"><span>.col-md-4</span></div>
                                        <div className="col-md-4"><span>.col-md-4</span></div>
                                    </div>
                                    <div className="show-grid row">
                                        <div className="col-md-3"><span>.col-md-3</span></div>
                                        <div className="col-md-3"><span>.col-md-3</span></div>
                                        <div className="col-md-3"><span>.col-md-3</span></div>
                                        <div className="col-md-3"><span>.col-md-3</span></div>
                                    </div>
                                    <div className="show-grid row">
                                        <div className="col-md-3"><span>.col-md-3</span></div>
                                        <div className="col-md-6"><span>.col-md-6</span></div>
                                        <div className="col-md-3"><span>.col-md-3</span></div>
                                    </div>
                                    <div className="show-grid row">
                                        <div className="col-md-9"><span>.col-md-9</span></div>
                                        <div className="col-md-3"><span>.col-md-3</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Text Aligments</h3>
                                <p className="text-left">Left aligned text.</p>
                                <p className="text-center">Center aligned text.</p>
                                <p className="text-right">Right aligned text.</p>
                                <p className="text-justify">
                                    <strong>Justified text</strong>
                                    <br />
                                    Consequat te olim letalis premo ad hos olim odio olim indoles ut venio iusto. Euismod, sagaciter diam neque antehabeo blandit, jumentum transverbero luptatum. Lenis vel diam praemitto molior facilisi facilisi suscipere abico, ludus, at.
                        </p>
                            </div>
                            <div className="col-md-4">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Emphasis classNamees</h3>
                                <p className="text-muted">Fusce dapibus, tellus ac cursus commodo, tortor mauris nibh.</p>
                                <p className="text-primary">Nullam id dolor id nibh ultricies vehicula ut id elit.</p>
                                <p className="text-success">Duis mollis, est non commodo luctus, nisi erat porttitor ligula.</p>
                                <p className="text-info">Maecenas sed diam eget risus varius blandit sit amet non magna.</p>
                                <p className="text-warning">Etiam porta sem malesuada magna mollis euismod.</p>
                                <p className="text-danger">Donec ullamcorper nulla non metus auctor fringilla.</p>
                            </div>
                            <div className="col-md-4">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Addresses</h3>
                                <address>
                                    <strong>Twitter, Inc.</strong><br />
                                    795 Folsom Ave, Suite 600<br />
                                    San Francisco, CA 94107<br />
                                    <abbr title="Phone">P:</abbr> (123) 456-7890
                        </address>
                                <address>
                                    <strong>Full Name</strong><br />
                                    <a href="mailto:#">first.last@example.com</a>
                                </address>
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Abbreviation</h3>
                                <p>An abbreviation of the word attribute is <abbr title="attribute">attr</abbr> <br /><abbr title="HyperText Markup Language" className="initialism">HTML</abbr> is the best thing since sliced bread.</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-6">
                                <blockquote className="blockquote-2">
                                    <p>There is no design without discipline. There is no discipline without intelligence.</p>
                                    <footer><cite title="Source Title">Steven Snell Google</cite></footer>
                                </blockquote>
                            </div>
                            <div className="col-sm-6">
                                <blockquote className="blockquote-3">
                                    <p>There is no design without discipline. There is no discipline without intelligence.</p>
                                    <footer><cite title="Source Title">Steven Snell Google</cite></footer>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100 pb-0">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-sm-12">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Dropcaps</h3>
                            </div>
                            <div className="col-sm-4">
                                <p><span className="dropcap">D</span>Consequat te olim letalis premo ad hos olim odio olim indoles ut venio iusto. Euismod, sagaciter diam neque antehabeo blandit, jumentum transverbero luptatum. Lenis vel diam praemitto molior facilisi facilisi suscipere abico, ludus, at.</p>
                            </div>
                            <div className="col-sm-4">
                                <p><span className="dropcap2 bg-secondary">D</span>Consequat te olim letalis premo ad hos olim odio olim indoles ut venio iusto. Euismod, sagaciter diam neque antehabeo blandit, jumentum transverbero luptatum. Lenis vel diam praemitto molior facilisi facilisi suscipere abico, ludus, at.</p>
                            </div>
                            <div className="col-sm-4">
                                <p><span className="dropcap2 rounded-circle bg-primary">D</span>Consequat te olim letalis premo ad hos olim odio olim indoles ut venio iusto. Euismod, sagaciter diam neque antehabeo blandit, jumentum transverbero luptatum. Lenis vel diam praemitto molior facilisi facilisi suscipere abico, ludus, at.</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="wide-tb-100">
                    <div className="container">
                        <div className="row pb-4">
                            <div className="col-sm-12 col-md-3">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Bullet Style</h3>
                                <ul className="list-unstyled icons-listing theme-orange mb-0">
                                    <li><i className="icofont-check"></i>Deliver Environmentally Responsible Client Services</li>
                                    <li><i className="icofont-check"></i>Be an Active Community Partner</li>
                                    <li><i className="icofont-check"></i>Drive Continuous Improvement</li>
                                    <li><i className="icofont-check"></i>Clearance and compliance service</li>
                                </ul>
                            </div>
                            <div className="col-sm-12 col-md-3">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Bullet Style Light</h3>
                                <ul className="list-unstyled icons-listing theme-light mb-0">
                                    <li><i className="icofont-check"></i>Deliver Environmentally Responsible Client Services</li>
                                    <li><i className="icofont-check"></i>Be an Active Community Partner</li>
                                    <li><i className="icofont-check"></i>Drive Continuous Improvement</li>
                                    <li><i className="icofont-check"></i>Clearance and compliance service</li>
                                </ul>
                            </div>
                            <div className="col-sm-12 col-md-3">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Bullet Style Dark</h3>
                                <ul className="list-unstyled icons-listing theme-dark mb-0">
                                    <li><i className="icofont-check"></i>Deliver Environmentally Responsible Client Services</li>
                                    <li><i className="icofont-check"></i>Be an Active Community Partner</li>
                                    <li><i className="icofont-check"></i>Drive Continuous Improvement</li>
                                    <li><i className="icofont-check"></i>Clearance and compliance service</li>
                                </ul>
                            </div>
                            <div className="col-sm-12 col-md-3">
                                <h3 className="h3-sm fw-6 txt-blue mb-4">Different Bullet Style</h3>
                                <ul className="list-unstyled icons-listing theme-dark mb-0">
                                    <li><i className="icofont-check"></i>Deliver Environmentally Responsible Client Services</li>
                                    <li><i className="icofont-dotted-right"></i>Be an Active Community Partner</li>
                                    <li><i className="icofont-double-right"></i>Drive Continuous Improvement</li>
                                    <li><i className="icofont-thin-right"></i>Clearance and compliance service</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};
export default Content;
